import React from 'react'
import { Table, IconButton, Icon, Panel, ButtonGroup, Row, Col, Dropdown } from 'rsuite'
import { getValueFromOptions } from '../../utils/dataUtil'
import AttachFilesView from '../attachfiles/AttachFilesView'
import { startLoading, doneLoading } from '../../utils/loading'
import { getDownload } from '../../redux/actions/legalFollowHistory'
import { budgetFormat } from '../../utils/formatterUtil'
import moment from 'moment'

export default function TrackingHistoryLawResultView(props) {
  const { schema, title } = props

  const onDownload = async (fileObj) => {
    startLoading()
    console.log('fileObj ', fileObj)
    var file = await getDownload(fileObj.id)
    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    var file = await getDownload(fileObj.id)
    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.setAttribute('value', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  return (
    <>
      {schema && (
        <Panel header={title || ''} collapsible defaultExpanded bordered>
          <Row style={{ marginTop: 5 }}>
            <Col lg={8} md={8} sm={24} xs={24}>
              <b>{`${schema.lawStatus.label || 'สถานะทางกฎหมาย'}`} : </b>{' '}
              {getValueFromOptions(schema.lawStatus.options, schema.lawStatus.value) || ''}
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <b>{`${schema.lawSubStatus.label || 'สถานะย่อยทางกฎหมาย'}`} : </b>{' '}
              {getValueFromOptions(schema.lawSubStatus.options, schema.lawSubStatus.value) || '-'}
            </Col>
          </Row>

          <Row style={{ marginTop: 5 }}>
            <Col lg={8} md={8} sm={24} xs={24}>
              <b>{`${schema.trackingDate.label || 'วันที่ดำเนินการ'}`} : </b>{' '}
              {schema?.trackingDate?.value || '-'}
            </Col>
            {schema?.lawStatus?.value == '21' && (
              <>
                <Col lg={8} md={8} sm={24} xs={24}>
                  <b>{`${schema.edforcementDate.label || 'วันที่บังคับคดี'}`} : </b>{' '}
                  {schema?.edforcementDate?.value
                    ? moment(schema?.edforcementDate?.value).format('DD/MM/YYYY')
                    : ''}
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                  <b>
                    {`${schema.cerrentStatuteOfLimitation.label || 'ระยะเวลาอายุความปัจจุบัน'}`}{' '}
                    :{' '}
                  </b>{' '}
                  {schema?.cerrentStatuteOfLimitation?.value || ''}
                </Col>
              </>
            )}
          </Row>

          {schema?.lawStatus?.value == '21' && (
            <>
              <Row style={{ marginTop: 5 }}>
                <Col lg={8} md={8} sm={24} xs={24}>
                  <b>{`${schema.exepEdforcementDate.label || 'วันที่หมดอายุความบังคับคดี'}`} : </b>{' '}
                  {schema?.exepEdforcementDate?.value
                    ? moment(schema?.exepEdforcementDate?.value).format('DD/MM/YYYY')
                    : ''}
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                  <b>{`${schema.judgmentDebt.label || 'จำนวนเงินที่มีคำพิพากษา'}`} : </b>{' '}
                  {budgetFormat(schema?.judgmentDebt?.value) || '0'}
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                  <b>{`${schema.principle.label || 'เงินต้น'}`} : </b>{' '}
                  {budgetFormat(schema?.principle?.value) || '0'}
                </Col>
              </Row>

              <Row style={{ marginTop: 5 }}>
                <Col lg={8} md={8} sm={24} xs={24}>
                  <b>{`${schema.interestRate.label || 'อัตราดอกเบี้ย'}`} : </b>{' '}
                  {budgetFormat(schema?.interestRate?.value) || '0'}
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                  <b>{`${schema.paymentDate.label || 'วันที่ชำระเงิน'}`} : </b>{' '}
                  {schema?.paymentDate?.value
                    ? moment(schema?.paymentDate?.value).format('DD/MM/YYYY')
                    : ''}
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                  <b>{`${schema.amountPaid.label || 'จำนวนเงินที่ชำระ'}`} : </b>{' '}
                  {budgetFormat(schema?.amountPaid?.value) || '0'}
                </Col>
              </Row>

              <Row style={{ marginTop: 5 }}>
                <Col lg={8} md={8} sm={24} xs={24}>
                  <b>{`${schema.remainingPrincipalAmount.label || 'จำนวนเงินต้นคงเหลือ'}`} : </b>{' '}
                  {budgetFormat(schema?.remainingPrincipalAmount?.value) || '0'}
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                  <b>{`${schema.remainingInterest.label || 'ดอกเบี้ยคงเหลือ'}`} : </b>{' '}
                  {budgetFormat(schema?.remainingInterest?.value) || '0'}
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                  <b>{`${schema.remainingBalance.label || 'จำนวนเงินที่ชำระ'}`} : </b>{' '}
                  {budgetFormat(schema?.remainingBalance?.value) || '0'}
                </Col>
              </Row>

              <Row style={{ marginTop: 5 }}>
                <Col lg={8} md={8} sm={24} xs={24}>
                  <b>{`${schema.riskLevel.label || 'ระดับความเสี่ยง'}`} : </b>{' '}
                  {getValueFromOptions(schema.riskLevel.options, schema.riskLevel.value) || ''}
                </Col>
              </Row>
            </>
          )}

          <Row style={{ marginTop: 25 }}>
            <Col lg={24} md={24} sm={24} xs={24}>
              <b>{`${schema.noteOfTracking.label || 'รายละเอียดการติดตามคดี'}`} : </b>
              <br />

              <div
                style={{ textIndent: '1.5em' }}
                dangerouslySetInnerHTML={{ __html: schema?.noteOfTracking?.value || '-' }}
              ></div>
            </Col>
          </Row>

          <Row style={{ marginTop: 50 }}>
            <Col lg={24} md={24} sm={24} xs={24}>
              <AttachFilesView
                schema={schema.attachFiles}
                onDownload={onDownload}
                onPreview={onPreview}
              />
            </Col>
          </Row>
        </Panel>
      )}
    </>
  )
}
